import {
  GavelOutlined,
  InventoryOutlined,
  PolicyOutlined,
  Settings,
  ShoppingCartOutlined,
  type SvgIconComponent,
} from '@mui/icons-material'
import AiIcon from '@omnea-app/icons/settings/ai.svg'
import ApiIcon from '@omnea-app/icons/settings/api.svg'
import AuditLogIcon from '@omnea-app/icons/settings/audit-log.svg'
import CoreDataIcon from '@omnea-app/icons/settings/core-data.svg'
import DocumentStorageIcon from '@omnea-app/icons/settings/document-storage.svg'
import ImportIcon from '@omnea-app/icons/settings/import.svg'
import NotificationsIcon from '@omnea-app/icons/settings/notifications.svg'
import PreferencesIcon from '@omnea-app/icons/settings/preferences.svg'
import ProductCatalogueIcon from '@omnea-app/icons/settings/product-catalogue.svg'
import QuestionsIcon from '@omnea-app/icons/settings/questions.svg'
import RiskAlertsIcon from '@omnea-app/icons/settings/risk-alerts.svg'
import RiskManagementIcon from '@omnea-app/icons/settings/risk-management.svg'
import SecurityIcon from '@omnea-app/icons/settings/security.svg'
import SourcingIcon from '@omnea-app/icons/settings/sourcing.svg'
import UserPropertiesIcon from '@omnea-app/icons/settings/user-properties.svg'
import UsersIcon from '@omnea-app/icons/settings/users.svg'
import WorkflowsIcon from '@omnea-app/icons/settings/workflows.svg'
import { IconComponent } from '@omnea-app/icons/types'

export const getSettingsIconByName = (name: string) => {
  const settingsIconsMap: Record<string, IconComponent | SvgIconComponent> = {
    ai: AiIcon,
    auctions: GavelOutlined,
    api: ApiIcon,
    'core-data': CoreDataIcon,
    'document-storage': DocumentStorageIcon,
    import: ImportIcon,
    notifications: NotificationsIcon,
    policies: PolicyOutlined,
    preferences: PreferencesIcon,
    'risk-management': RiskManagementIcon,
    'risk-alerts': RiskAlertsIcon,
    security: SecurityIcon,
    'user-properties': UserPropertiesIcon,
    users: UsersIcon,
    workflows: WorkflowsIcon,
    questions: QuestionsIcon,
    'audit-log': AuditLogIcon,
    sourcing: SourcingIcon,
    'product-catalogue': ProductCatalogueIcon,
    'product-supplier-categories': ProductCatalogueIcon,
    'punchout-catalogues': ShoppingCartOutlined,
    'hosted-catalogues': ShoppingCartOutlined,
    catalogues: ShoppingCartOutlined,
    'goods-receipting': InventoryOutlined,
  }
  const FallbackIcon = Settings

  const Icon = settingsIconsMap[name]
  if (!Icon) {
    return <FallbackIcon sx={{ width: 18, height: 18 }} />
  }

  return <Icon style={{ width: 18, height: 18 }} />
}
